module.exports = __webpack_public_path__ + "img/bg.708e607a.png";